import React from 'react';
import { StyledContent, StyledFormStack, StyledHeaderStack, StyledTitleStack, styles } from '../UnlockForm/UnlockForm.styles';
import { ButtonV2, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { body4ToSubHeadingOverride, hed6ToSubHeadingOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { useUnlockDialogButtonStyles } from '../useUnlockDialogButtonStyles';

interface AskHostSuccessFormProps {
  onClose: () => void;
}

export const AskHostSuccessForm: React.FC<AskHostSuccessFormProps> = ({ onClose }) => {
  const { t2 } = useTranslation('guestUnlock');
  const { title, subtitle, submitButtonText } = t2('askHostSuccessForm');
  const buttonStyles = useUnlockDialogButtonStyles();

  return (
    <StyledContent __css={styles.content}>
      <StyledHeaderStack>
        <StyledTitleStack>
          <GuestSiteTypographyOverride override={hed6ToSubHeadingOverride}>
            <TextV2 typographyVariant="hed6">{title}</TextV2>
          </GuestSiteTypographyOverride>
          <GuestSiteTypographyOverride override={body4ToSubHeadingOverride}>
            <TextV2 typographyVariant="body4">{subtitle}</TextV2>
          </GuestSiteTypographyOverride>
        </StyledTitleStack>
      </StyledHeaderStack>
      <StyledFormStack
        spacing={6}
        __css={styles.formStack}
      >
        <ButtonV2
          width={'100%'}
          shape="rounded"
          variant="outline"
          onClick={onClose}
          {...buttonStyles}
        >
          {submitButtonText}
        </ButtonV2>
      </StyledFormStack>
    </StyledContent>
  );
};
